import React from "react";
import BlogThirtyEight from "../component/BlogThirtyEight";

function BlogThirtyEightContainer() {
  return <BlogThirtyEight />;
}

export default BlogThirtyEightContainer;
